import { UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { AllGrnReportResponse, AllGrnResponseModel, GrnDetailViewResponseModel, GrnItemReceivedQtyResponse, GrnItemReturnResponse, GrnNumberResponseModel, GrnQtyResponseModel, GrnReturnAutoFillModel } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PurchaseOrderIdRequest } from '../po-creation/dto/po-id.request';
import { GrnItemReceivedQtyRequest } from './dto/grn-item-received-qty-request';
import { GrnQtyRequest } from './dto/grn-qty-request';
import { GrnIdRequest } from './dto/grn-request';
import { grnResponse } from './dto/grn-response';
import { GrnDto } from './dto/grn.dto';
import { invoiceNumberRequest } from './dto/invoice-number-req';
import { GrnReportRequest } from './grn-report-request';
import { GrnService } from './grn.service';


@Controller('grn')
@ApiTags('grn')

export class GrnController {
  constructor(
    private grnService: GrnService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
  ) { }

  /**
 * creates or a GRN
 * @param saleGrnDto Grn DTO
 * @returns GrnResponse
 */
  @Post('/createGrn')
  async createGrn(@Body() grnDto: GrnDto): Promise<grnResponse> {
    try {
      return await this.grnService.createGrn(grnDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(grnResponse, error);
    }
  }

  /**
* get GRN Qty against PO
* @param poIdReq poIdReq
* @returns GrnResponse
*/
  @Post('/getGrnQtyByPoId')
  async getGrnQtyByPoId(@Body() poIdReq: GrnQtyRequest): Promise<GrnQtyResponseModel> {
    try {
      return await this.grnService.getGrnQtyByPoId(poIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnQtyResponseModel, error);
    }
  }

  /**
* get GRN details against PO
* @param poIdReq poIdReq
* @returns GrnResponse
*/
  @Post('/getGrnByPoId')
  async getGrnByPoId(@Body() poIdReq: GrnQtyRequest): Promise<any> {
    try {
       return await this.grnService.getGrnByPoId(poIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(grnResponse, error);
    }
  }

  /**
* get GRN details 
* @param 
* @returns AllGrnResponseModel
*/
  @Post('/getAllGrnDetails')
  async getAllGrnDetails(@Body() req?: UnitRequest): Promise<AllGrnResponseModel> {
    try {
      return await this.grnService.getAllGrnDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error);
    }
  }

    /**
* get GRN details 
* @param 
* @returns AllGrnResponseModel
*/
@Post('/getAllGrnData')
async getAllGrnData(@Body() req?: UnitRequest): Promise<AllGrnResponseModel> {
  try {
    return await this.grnService.getAllGrnData(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error);
  }
}

  

  /**
* get PO against POId
* @param poIdReq poIdReq
* @returns GrnResponse
*/
  @Post('/getGrnDataById')
  async getGrnDataById(@Body() grnIdReq: GrnIdRequest): Promise<GrnDetailViewResponseModel> {
    try {
      return await this.grnService.getGrnDataById(grnIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnDetailViewResponseModel, error);
    }
  }

  @Post('/getGrnDataByIdForReturn')
  async getGrnDataByIdForReturn(@Body() grnIdReq: GrnIdRequest): Promise<GrnItemReturnResponse> {
    try {
      return await this.grnService.getGrnDataByIdForReturn(grnIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnItemReturnResponse, error);
    }
  }

  @Post('getAllActiveGrnNumbers')
  async getAllActiveGrnNumbers(@Body() req?: UnitRequest): Promise<GrnNumberResponseModel> {
    try {
      return await this.grnService.getAllActiveGrnNumbers(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnNumberResponseModel, error);
    }
  }

  @Post('getGrnReturnAutoFillDataByGrnId')
  async getGrnReturnAutoFillDataByGrnNumber(@Body() grnIdReq: GrnIdRequest): Promise<GrnReturnAutoFillModel> {
    try {
      return this.grnService.getGrnReturnAutoFillDataByGrnNumber(grnIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnReturnAutoFillModel, error);
    }
  }

  @Post('getGrnItemReceivedQtyByGrnIdandItem')
  async getGrnItemReceivedQtyByGrnIdandItem(@Body() grnItemReq: GrnItemReceivedQtyRequest): Promise<GrnItemReceivedQtyResponse> {
    try {
      return this.grnService.getGrnItemReceivedQtyByGrnIdandItem(grnItemReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnItemReceivedQtyResponse, error);
    }
  }
  @Post('/getAllGrnReport')
  async getAllGrnReport(@Body() req?: GrnReportRequest): Promise<AllGrnReportResponse> {
    try {
      return await this.grnService.getAllGrnReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnReportResponse, error);
    }
  }
  @Post('getSoDropForGrnReport')
  async getSoDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getSoDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getPoDropForGrnReport')
  async getPoDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getPoDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getItemSubDropForGrnReport')
  async getItemSubDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getItemSubDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getItemDropForGrnReport')
  async getItemDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getItemDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getVendorDropForGrnReport')
  async getVendorDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getVendorDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getgrnUsage')
  async getGrnUsage():Promise<any>{
  try{
      return await this.grnService.getGrnUsage();
   }catch(error){
       return this.applicationExceptionHandler.returnException(CommonResponse,error)
   }
  }

  @Post('/getTransferredSosDataForGrnGrid')
  async getTransferredSosDataForGrnGrid(@Body() req?: UnitRequest): Promise<AllGrnReportResponse> {
    try {
      return await this.grnService.getTransferredSosDataForGrnGrid(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnReportResponse, error);
    }
  }
  

  @Post('/grninfoforpending')
  async grninfoforpending(@Body() req?: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.grninfoforpending(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getLocationMappedGrns')
  async getLocationMappedGrns(@Body() req:invoiceNumberRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getLocationMappedGrns(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

}
